import { CSS } from "@dnd-kit/utilities";

const { useSortable } = require("@dnd-kit/sortable");
const { TableRow, TableCell } = require("@mui/material");

const SortableTableRow = ({
  item,
  index,
  columns,
  onRowClick,
  getRowStyle,
  renderCellContent,
  columnWidth,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: item.id,
      data: { ...item },
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...getRowStyle(item, index),
    cursor: onRowClick ? "pointer" : "default",
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      onClick={() => onRowClick && onRowClick(item, index)}
      {...attributes}
      {...listeners}
    >
      {columns.map((column) => (
        <TableCell
          key={column.key}
          align={column.align || "left"}
          sx={{ width: columnWidth }}
        >
          {renderCellContent(column, item)}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default SortableTableRow;
